// @flow
import { ACCOUNTS_BACKEND_URL } from "../../Constants/Global/apiConstants";
import axios from "axios";

export function loginFormSubmit(payload: Object) {
  return axios.create({
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: `${ACCOUNTS_BACKEND_URL}/get_auth_token`,
    data: payload
  });
}



// WEBPACK FOOTER //
// ./src/Api/PublicAccountPages/login.js